import { useQuery } from '@apollo/client/react';
import type { RequestQuery } from '../../../graphql/generated/graphql.ts';
import { REQUEST_QUERY } from './useRequestDetailsQuery.gql';

export type Request = NonNullable<RequestQuery['request']>;
export type Order = NonNullable<RequestQuery['request']>['orders'][number];
export type OrderParameter = NonNullable<RequestQuery['request']>['orders'][number]['orderParameters'][number];
export type OrderFile = NonNullable<RequestQuery['request']>['orders'][number]['orderFiles'][number];
export type OrderLabel = NonNullable<RequestQuery['request']>['orders'][number]['orderLabels'][number];
export type OrderFormField = NonNullable<RequestQuery['request']>['orders'][number]['orderForms'][number]['fields'][number];

export const useRequestDetailsQuery = (requestId: string | null, doctorId: string) => {
  return useQuery(REQUEST_QUERY, {
    variables: {
      id: requestId ?? '',
      doctorId: doctorId,
    },
    skip: !requestId,
  });
};
